import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgListCheckDouble = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M8 8H14H8Z",
			fill: "#EAB308"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8 12H14H8Z",
			fill: "#EAB308"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8 8H14M8 12H14M8 4L14 4M2 5.40311L3.2649 6.66667C3.87328 5.60287 4.71522 4.69107 5.72725 4M2 10.7364L3.2649 12C3.87328 10.9362 4.71522 10.0244 5.72725 9.33333",
			stroke: "#EAB308",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgListCheckDouble);
export default ForwardRef;
